// extracted by mini-css-extract-plugin
export default {"systemDownloadHistory":"SystemDownloadHistory_systemDownloadHistory__N9JAy","details":"SystemDownloadHistory_details__Y-Edp","headline":"SystemDownloadHistory_headline__bc8Zk"};